import { motion } from "framer-motion";
import { Leaf } from "lucide-react";
import { ASSETS, PHONE_DISPLAY, PHONE_TEL } from "@/lib/constants";

export const Ecorb = () => {
  return (
    <section className="relative py-16 md:py-20 border-t border-white/5 overflow-hidden" data-testid="ecorb-section">
      {/* Marquee - Background */}
      <div className="overflow-hidden -mb-2 opacity-[0.08] absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="marquee-track flex whitespace-nowrap font-serif italic text-[8rem] md:text-[14rem] text-[#D4AF37] leading-none">
          {Array.from({ length: 6 }).map((_, i) => (
            <span key={i} className="px-12">Ecorb Group · World-Class Facilities ·</span>
          ))}
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-6 md:px-10 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="text-center"
        >
          {/* Image above "Powered by Ecorb" - 4x larger */}
          <div className="flex justify-center mb-6">
            <img 
              src={ASSETS.ecorb} 
              alt="Ecorb" 
              className="h-64 md:h-96 w-auto object-contain"
            />
          </div>

          <div className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.4em] text-[#D4AF37] mb-6">
            <Leaf className="w-3.5 h-3.5" />
            Powered by Ecorb Group of companies
          </div>
          <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-[#F8F6F0] leading-tight tracking-tight">
            World-Class Facilities
            <span className="block italic gold-text">With Eco Values...</span>
          </h2>
          <div className="divider-gold w-24 mx-auto my-10" />
          <p className="text-base md:text-lg text-[#A0A0A0] font-light leading-relaxed max-w-3xl mx-auto">
            With a passion for a green & liveable environment, ECORB was incorporated to mastermind
            state-of-the-art modernistic infrastructures — but with Eco values. Since inception in
            2017, the Group has done extremely well to create sustainable realty solutions that
            truly respect nature and reflect Eco-friendly features. The Group has set a vision of
            positively impacting <span className="text-[#D4AF37]">5 Lakh people</span> in the coming
            five years.
          </p>
        </motion.div>
      </div>
    </section>
  );
};